import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container } from 'react-bootstrap';
import dayjs from 'dayjs';
import { requestsActions } from '../../../actions';
import { RequestData } from './RequestData';
import { RequestInfo } from './RequestInfo';
import { RequestUsers } from './RequestUsers';
import RequestFiles from './RequestFiles';
import { RequestComments } from './RequestComments';

function useMainDataForRequest(requestNum, requests) {
    return useMemo(() => {
        if (!requests) return [];
        const request = [...requests.author, ...requests.participant].find((req) => +requestNum === +req.num);
        if (request) {
            return [request, request.nomination];
        }
        return [];
    }, [requestNum, requests]);
}

function RequestPage(props) {
    const { user, requests, errors, getting, clearErrors, updateData, addUser, rmUser, updateUser, addComment } = props;
    const { requestNum } = useParams();
    const [request, nomination] = useMainDataForRequest(requestNum, requests);
    const readOnly = useMemo(() => {
        return (
            !user || // не авторизован (почему-то)
            !request || // нет такой заявки
            user.id !== request.author.id || // не автор заявки (просто участник)
            ([3, 4].includes(request.status.id) && !request.forceEditable) || // одобрена или отклонена
            // прошел срок завершения сбора материалов
            (dayjs().isAfter(dayjs(nomination.changeStopDate)) && !request.forceEditable) ||
            // прием заявок не открыт (если вдруг пришлось сдвинуть, но заявки уже созданы)
            dayjs().isBefore(dayjs(nomination.regOpenDate))
        );
    }, [user, request, nomination]);

    useEffect(() => {
        return () => clearErrors();
    }, [clearErrors]);

    return (
        <Container className="py-5">
            {request ? (
                <>
                    <RequestInfo request={request} user={user} />
                    <RequestUsers
                        request={request}
                        executing={getting}
                        addUser={addUser}
                        rmUser={rmUser}
                        updateUser={updateUser}
                        errors={errors}
                        clearErrors={clearErrors}
                        readOnly={readOnly}
                    />
                    <RequestData
                        request={request}
                        executing={getting}
                        updateData={updateData}
                        errors={errors}
                        clearErrors={clearErrors}
                        readOnly={readOnly}
                    />
                    <RequestFiles request={request} readOnly={readOnly} />
                    <RequestComments request={request} executing={getting} addComment={addComment} />
                </>
            ) : (
                <h2 className="text-center">Нет такой заявки</h2>
            )}
        </Container>
    );
}

function mapStateToProps(state) {
    const {
        requests: { requests, getting, errors },
        auth: { user },
    } = state;
    return { requests, getting, errors, user };
}

const actionsToProps = {
    clearErrors: requestsActions.clearErrors,
    updateData: requestsActions.updateData,
    addUser: requestsActions.addUser,
    rmUser: requestsActions.rmUser,
    updateUser: requestsActions.updateUser,
    addComment: requestsActions.addComment,
};

export default connect(mapStateToProps, actionsToProps)(RequestPage);
